import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import {PhotoSwipeGallery} from '../components/React-Photoswipe';
import GalleryMenu from '../components/GalleryMenu';
import '../components/React-Photoswipe/photoswipe.css';

require('jquery.scrollto');
export default class Gallery extends Component {
    constructor(props) {
        super(props);
        this.renderThumbnail = this.renderThumbnail.bind(this);
    }

    updateTitle() {
        const section = this.props.params.tag;
        let sectionName;
        if (section === 'IKEA') {
            sectionName = 'IKEA';
        } else if (section === 'furniture') {
            sectionName = 'Furniture';
        } else if (sectionName === 'kitchen') {
            sectionName = 'Kitchens';
        } else {
            sectionName = 'C&A Assembly & Installation Solution';
        }
        document.title = `Gallery - ${sectionName}`;
    }

    componentDidMount() {
        document.title = `Gallery - C&A Assembly & Installation Solution`;
        this.getImages();
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            this.updateTitle();
            setTimeout(() => {
                this.getImages()
            }, 0)
        });
    }
    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return (
            <div>
                <GalleryMenu />
                <PhotoSwipeGallery items={this.props.galleryImages} thumbnailContent={this.renderThumbnail}/>
            </div>
        )
    }

    getImages() {
        const { tag } = this.props.params;

        axios.get(`https://res.cloudinary.com/cna-net-au/image/list/${tag || 'gallery'}.json`).then(function(res) {
            this.props.clearGalleryImages();
            const images = _.reverse(_.sortBy(res.data.resources, ['created_at']));
            for (let i = 0, len = images.length; i < len; i++) {
                this.props.addGalleryImage({
                    src: `https://res.cloudinary.com/cna-net-au/image/upload/l_logo12132434256,o_50,w_860/${images[i].public_id}.jpg`,
                    thumbnail: `https://res.cloudinary.com/cna-net-au/image/upload/c_thumb,f_auto,h_288,w_288/${images[i].public_id}.jpg`,
                    w: `${images[i].width}`,
                    h: `${images[i].height}`,
                    title: ''
                })
            }
        }.bind(this));
    }
    renderThumbnail(item) {
        return (
            <img data-src={item.thumbnail} width={288} height={288} alt="" className="lazyload"/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Gallery.js